import { Box, styled } from '@mui/material';
import { KPI_CARD_SIZES } from '../constants';
import { StatisticSize } from '../types';

export const LabelWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => {
  const sizeConfig = KPI_CARD_SIZES[size] ?? KPI_CARD_SIZES.md;

  return {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    fontSize: sizeConfig.labelFontSize,
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  };
});
